import React from "react";
import ReactDOM from "react-dom";
import { Router, Link } from "@reach/router";
import Details from "./details";
import SearchParams from "./SearchParams";

const App = () => {
  return (
    <div>
      <div class="top-section">
        <header>
          <Link to="/">Adopt Me!</Link>
        </header>
        <h3>
          <a href="https://github.com/ai-is-awesome/adopt-me" target="_blank">
            Link to source{" "}
          </a>
        </h3>
      </div>
      <Router>
        <SearchParams path="/" />
        <Details path="details/:id" />
      </Router>
    </div>
  );
};
ReactDOM.render(React.createElement(App), document.getElementById("root"));
